/**
 * trésjolie — voraussichtlicher Liefertermin
 *
 * Rechnet ab heute eine Spanne in Werktagen aus und schreibt sie in das
 * Element. Samstag und Sonntag zaehlen nicht mit. Bestellungen nach 14 Uhr
 * gehen erst am naechsten Werktag in die Produktion.
 *
 * Bewusst im Browser gerechnet: Shopify legt fertige Seiten zwischen, ein in
 * Liquid gerechnetes Datum waere fuer den naechsten Besucher womoeglich von
 * gestern.
 */
(function () {
  var MONATE = [
    'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
    'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez',
  ];

  /** Zaehlt anzahl Werktage auf ein Datum drauf */
  function plusWerktage(start, anzahl) {
    var d = new Date(start.getTime());
    var offen = anzahl;
    while (offen > 0) {
      d.setDate(d.getDate() + 1);
      var tag = d.getDay();
      if (tag !== 0 && tag !== 6) offen--;
    }
    return d;
  }

  function kurz(d) {
    return d.getDate() + '. ' + MONATE[d.getMonth()];
  }

  function setzen(el) {
    var von = parseInt(el.dataset.von, 10);
    var bis = parseInt(el.dataset.bis, 10);
    if (!von || !bis || bis < von) return;

    var start = new Date();
    // Nach 14 Uhr geht nichts mehr raus, dann zaehlt erst morgen
    if (start.getHours() >= 14) start = plusWerktage(start, 1);

    var a = plusWerktage(start, von);
    var b = plusWerktage(start, bis);

    el.textContent =
      'Voraussichtliche Lieferung zwischen ' + kurz(a) + ' und ' + kurz(b);
  }

  function alle() {
    document.querySelectorAll('.tj-liefertermin').forEach(setzen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  // Nach einem Variantenwechsel baut Dawn den Bereich neu auf
  document.addEventListener('shopify:section:load', alle);
  document.addEventListener('variant:change', alle);
})();
